import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  // DialogActions,
  // Button
} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

let mostrar = null;


// Esta es la función que se invocará en lugar de alert() (que muestra el título: "host dice" y no sirve)
export function verAviso(texto) {
  if (mostrar) {
    mostrar(texto);
  }
}


// Este componente se pinta una sola vez en la aplicación
export default function VerAviso() {

  const [mensaje, setMensaje] = useState(null);


  // Guardamos la función que cambia el estado del diálogo
  mostrar = setMensaje;


  return (
    <Dialog
      open={mensaje !== null}
      onClose={() => setMensaje(null)}
    >

      <DialogTitle  sx={{ fontSize: "1rem", display: "flex",
    justifyContent: "space-between",
    alignItems: "center"}}>
        Aviso
        <IconButton
          onClick={() => setMensaje(null)}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>


      <DialogContent sx={{ fontSize: "0.9rem" }}>        
        {mensaje}
      </DialogContent>


      {/* <DialogActions>

        <Button onClick={() => setMensaje(null)} className="btn-azul text-end">
          Salir
        </Button>

      </DialogActions> */}


    </Dialog>
  );
}